module.exports = __webpack_public_path__ + "img/apariencia_de_concreto.c75d03a6.png";